import { backendPy } from "System/system";
import store from "System/reduxStore";



// -------------------------------------------------------
// -------------------------------------------------------
export const getDashboardData = (cb) => async (dispatch) => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("dashboard", "read", {
    projectid: id, datapath,
  });
  if(result.data) {
    dispatch({type: "SET_DASHBOARD_DATA", dashboard: result.data});
  }
  cb();
};